import { mapGetters } from 'vuex'

export default {
  name: 'maintenance',

  computed: {
    ...mapGetters({
      'applicationMaintenance': 'contextStore/applicationMaintenance'
    }),

    maintenanceMessage () {
      return this.applicationMaintenance.message || this.$t('label.maintenance')
    },

    globalMaintenance () {
      return !!this.applicationMaintenance.global
    }
  }
}
